/**
 * The Android app opens https://app.brocoded.cloud links (a QR scanned with the system camera, a sign-in return) as App
 * Links. Its WebView always loads the app's start page, so the link it was opened with is handed to the page here:
 * at launch (`getLaunchUrl`) and while the app is already running (`appUrlOpen`). Only links on this app's own origin
 * are followed. A no-op in a browser.
 */
const app = (): any => {
  const cap = (window as any).Capacitor;
  return cap?.isNativePlatform?.() ? cap.Plugins?.App ?? null : null;
};

function follow(url: string): boolean {
  try {
    if (new URL(url).origin !== location.origin || url === location.href) return false;
    if (sessionStorage.getItem("foreman.link") === url) return false; // already followed (the reload would ask again)
    sessionStorage.setItem("foreman.link", url);
    location.replace(url);
    return true;
  } catch {
    return false;
  }
}

/** Resolves true when the app was opened with a link and the page is navigating to it (so don't render the start page). */
export async function followNativeLinks(): Promise<boolean> {
  const a = app();
  if (!a) return false;
  try {
    void a.addListener("appUrlOpen", (e: { url: string }) => follow(e.url));
    const launch = (await Promise.race([a.getLaunchUrl(), new Promise((r) => setTimeout(() => r(null), 800))])) as { url?: string } | null;
    return !!launch?.url && follow(launch.url);
  } catch {
    return false;
  }
}
